/*============================================================================
  Cart drawer — indirim kodu alanı

  Shopify Cart AJAX API'sinin discount desteğini kullanır:
  POST /cart/update.js  { discount: 'KOD1,KOD2' }
  Boş string tüm kodları kaldırır.

  Sepet markup'ı temanın kendi mekanizmasıyla yenilenir
  ('ajaxProduct:added' → theme.CartDrawer.cartForm.buildCart()).
==============================================================================*/
(function () {
  'use strict';

  var selectors = {
    container: '[data-discount-form]',
    input: '[data-discount-input]',
    applyBtn: '[data-discount-apply]',
    message: '[data-discount-message]',
    applied: '[data-discount-applied]'
  };

  var classes = {
    error: 'cart__discount-message--error',
    hide: 'hide',
    loading: 'cart__discount--loading'
  };

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function normalize(code) {
    return String(code || '').trim().toUpperCase();
  }

  function CartDiscount(container) {
    this.container = container;
    this.input = container.querySelector(selectors.input);
    this.button = container.querySelector(selectors.applyBtn);
    this.message = container.querySelector(selectors.message);
    this.applied = container.querySelector(selectors.applied);
    this.strings = {
      invalid: container.dataset.stringInvalid,
      error: container.dataset.stringError,
      remove: container.dataset.stringRemove
    };
    this.busy = false;

    this.init();
  }

  CartDiscount.prototype = {
    init: function () {
      this.button.addEventListener('click', this.onApply.bind(this));

      // Enter, drawer formunu submit edip checkout'a göndermesin
      this.input.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter' || evt.keyCode === 13) {
          evt.preventDefault();
          this.onApply();
        }
      }.bind(this));

      this.applied.addEventListener('click', function (evt) {
        var btn = evt.target.closest('[data-discount-remove]');
        if (!btn) return;
        evt.preventDefault();
        this.removeCode(btn.dataset.discountRemove);
      }.bind(this));

      this.getCart().then(this.render.bind(this)).catch(function () {});
    },

    /*========================================================================
      Ağ katmanı
    ========================================================================*/
    getCart: function () {
      return fetch(root() + 'cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      }).then(this.toJSON);
    },

    setCodes: function (codes) {
      return fetch(root() + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: codes.join(',') })
      }).then(this.toJSON);
    },

    toJSON: function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed: ' + response.status);
      }
      return response.json();
    },

    /*========================================================================
      Sepetteki kodlar
    ========================================================================*/
    codeList: function (cart) {
      return (cart && cart.discount_codes) || [];
    },

    // Sepetin gerçekten kabul ettiği kodlar
    activeCodes: function (cart) {
      return this.codeList(cart)
        .filter(function (entry) { return entry.applicable !== false; })
        .map(function (entry) { return entry.code; });
    },

    findCode: function (cart, code) {
      var wanted = normalize(code);
      return this.codeList(cart).filter(function (entry) {
        return normalize(entry.code) === wanted;
      })[0];
    },

    /*========================================================================
      Eylemler
    ========================================================================*/
    onApply: function () {
      var code = this.input.value.trim();
      if (!code || this.busy) return;

      var self = this;
      this.setBusy(true);
      this.clearMessage();

      this.getCart()
        .then(function (cart) {
          var codes = self.activeCodes(cart);
          if (!self.findCode({ discount_codes: codes.map(function (c) { return { code: c }; }) }, code)) {
            codes.push(code);
          }
          return self.setCodes(codes);
        })
        .then(function (cart) {
          var entry = self.findCode(cart, code);

          if (!entry || entry.applicable === false) {
            // Geçersiz kod sepette kalmasın, checkout'a taşınmasın
            return self.setCodes(self.activeCodes(cart)).then(function (cleaned) {
              self.render(cleaned);
              self.showMessage(self.strings.invalid, true);
            });
          }

          self.input.value = '';
          self.render(cart);
          self.refreshCart();
        })
        .catch(function (e) {
          console.error(e);
          self.showMessage(self.strings.error, true);
        })
        .then(function () { self.setBusy(false); });
    },

    removeCode: function (code) {
      if (this.busy) return;

      var self = this;
      var wanted = normalize(code);
      this.setBusy(true);
      this.clearMessage();

      this.getCart()
        .then(function (cart) {
          return self.setCodes(self.activeCodes(cart).filter(function (c) {
            return normalize(c) !== wanted;
          }));
        })
        .then(function (cart) {
          self.render(cart);
          self.refreshCart();
        })
        .catch(function (e) {
          console.error(e);
          self.showMessage(self.strings.error, true);
        })
        .then(function () { self.setBusy(false); });
    },

    // Temanın kendi sepet yenileme akışı: ürün satırları, indirim
    // dökümü ve ara toplam /cart?view=ajax'tan yeniden çizilir.
    refreshCart: function () {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    },

    /*========================================================================
      Arayüz
    ========================================================================*/
    render: function (cart) {
      var codes = this.activeCodes(cart);
      var remove = this.strings.remove;

      this.applied.innerHTML = codes.map(function (code) {
        var safe = code.replace(/[<>&"]/g, '');
        return '<span class="cart__discount-tag">' +
          '<span class="cart__discount-tag-code">' + safe + '</span>' +
          '<button type="button" class="cart__discount-tag-remove" ' +
          'data-discount-remove="' + safe + '" aria-label="' + remove + ' ' + safe + '">' +
          '<svg aria-hidden="true" focusable="false" viewBox="0 0 64 64"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>' +
          '</button></span>';
      }).join('');

      this.applied.classList.toggle(classes.hide, codes.length === 0);
    },

    showMessage: function (text, isError) {
      this.message.textContent = text;
      this.message.classList.toggle(classes.error, !!isError);
      this.message.classList.remove(classes.hide);
    },

    clearMessage: function () {
      this.message.textContent = '';
      this.message.classList.add(classes.hide);
    },

    setBusy: function (busy) {
      this.busy = busy;
      this.button.disabled = busy;
      this.container.classList.toggle(classes.loading, busy);
    }
  };

  function initAll() {
    document.querySelectorAll(selectors.container).forEach(function (el) {
      if (el.dataset.discountInit) return;
      el.dataset.discountInit = 'true';
      new CartDiscount(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor'da bölüm yeniden yüklenirse
  document.addEventListener('shopify:section:load', initAll);
})();
